import { useNavigate } from "react-router-dom";
import Logo from "../../assets/png/logo_tk (2).png";
const HeaderTwoTitle = () => {
  const navigate = useNavigate();
  return (
    <div onClick={() => navigate("/")} className="hidden cursor-pointer lg:inline-block text-left">
      <img src={Logo} alt="logo" className="h-[50px] object-contain"/>
    </div>
  );
};

export default HeaderTwoTitle;
